import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex grow basis-full flex-col justify-center text-center items-center h-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl lg:text-5xl" }, "Oops... ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " The page you're looking for doesn't exist ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createVNode(_component_ion_button, {
              class: "mt-5 w-full lg:w-auto",
              onClick: _ctx.home
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Home ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}